import React, { PropTypes } from 'react'
import { Link } from 'react-router'

function Stage(props) {
    const mainStyle = {}
    const stepStyle = {
        border: '1px solid #999',
        borderRadius: '50%',
        display: 'inline-block',
        height: 24,
        textAlign: 'center',
        width: 24,
    }
    const labelStyle = {}

    if (props.active) {
        stepStyle.borderColor = '#555'
        labelStyle.fontWeight = 'bold'
    }

    if (props.complete) {
        stepStyle.borderColor = 'rgb(122, 196, 87)'
        stepStyle.backgroundColor = 'rgb(122, 196, 87)'
        stepStyle.color = '#fff'
        labelStyle.textDecoration = 'line-through'
    }

    return (
        <div style={ mainStyle }>
            <span style={ stepStyle }>{ props.step }</span>
            { ' ' }
            <span style={ labelStyle }>
                { do {
                    if (props.link) {
                        <Link to={ props.link }>
                            { props.label }
                        </Link>
                    } else {
                        props.label
                    }
                }}
            </span>
        </div>
    )
}
Stage.propTypes = {
    active: PropTypes.bool,
    complete: PropTypes.bool,
    label: PropTypes.node,
    link: PropTypes.string,
    step: PropTypes.node,
}

export default function Progress(props) {
    const onboardingData = props.account.user.crew

    // If we don't have any personal data, we can't do much here...
    if (! onboardingData) {
        return null
    }

    // If onboarding is complete, don't show the progress at all
    if (onboardingData.onboarding_complete) {
        return null
    }

    return (
        <div className="content__inner">
            <div className="box">
                <div className="box__header">
                    <div className="box__title">
                        Onboarding Progress
                    </div>
                </div>
                <div className="box__content box__content--padded">
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td width="25%">
                                    <Stage
                                        active={ props.stage === 'personal' }
                                        complete={ onboardingData.personal_complete }
                                        label="Personal"
                                        link="/personal"
                                        step="1"
                                    />
                                </td>
                                <td width="25%">
                                    <Stage
                                        active={ props.stage === 'experience' }
                                        complete={ onboardingData.experience_complete }
                                        label="Experience"
                                        link={ do {
                                            if (onboardingData.personal_complete) {
                                                '/experience'
                                            } else {
                                                null
                                            }
                                        } }
                                        step="2"
                                    />
                                </td>
                                <td width="25%">
                                    <Stage
                                        active={ props.stage === 'crew-positions' }
                                        complete={ onboardingData.crew_positions_complete }
                                        label="Crew Position Selection"
                                        link={ do {
                                            if (
                                                onboardingData.personal_complete &&
                                                onboardingData.experience_complete
                                            ) {
                                                '/crew-positions'
                                            } else {
                                                null
                                            }
                                        } }
                                        step="3"
                                    />
                                </td>
                                <td width="25%">
                                    <Stage
                                        active={ props.stage === 'gear' }
                                        complete={ onboardingData.gear_tertiary_complete }
                                        label="Gear Details"
                                        link={ do {
                                            if (
                                                onboardingData.personal_complete &&
                                                onboardingData.experience_complete &&
                                                onboardingData.crew_positions_complete
                                            ) {
                                                // eslint-disable-next-line no-negated-condition
                                                if (! onboardingData.gear_primary_complete) {
                                                    '/gear/primary'
                                                // eslint-disable-next-line no-negated-condition
                                                } else if (! onboardingData.gear_secondary_complete) {
                                                    '/gear/secondary'
                                                } else {
                                                    '/gear/tertiary'
                                                }
                                            }
                                        } }
                                        step="4"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
Progress.propTypes = {
    account: PropTypes.shape({
        user: PropTypes.shape({
            crew: PropTypes.shape({
                onboarding_complete: PropTypes.bool,
                personal_complete: PropTypes.bool,
                experience_complete: PropTypes.bool,
                crew_positions_complete: PropTypes.bool,
                gear_primary_complete: PropTypes.bool,
                gear_secondary_complete: PropTypes.bool,
                gear_tertiary_complete: PropTypes.bool,
            }),
        }).isRequired,
    }).isRequired,
    stage: PropTypes.string,
}



// WEBPACK FOOTER //
// ./app/components/progress.js